import { inject, Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { finalize, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  public teamMembersLists: any = [];
  public httpService = inject(HttpService);
  public wpData: any = {
    member_id: '',
    status: '',
    theme_id: '',
    brand: '',
    therapeutic_area: '',
    indication: '',
    user_type: '',
  };

  myTasksData: any = {
    quarter: '',
    status: '',
    theme_id: '',
    type: '',
    untouched: '',
    year: new Date().getFullYear(),
  };

  outcomeData: any = {
    outcome_themes: '',
    outcome_groups: '',
    group_members: '',
    role: '',
    untouched_outcome: '',
    is_affiliate: 'no',
    parent_group: '',
    outcome_year: new Date().getFullYear(),
  };

  homeData: any = {
    outcome_themes: '',
    outcome_quarters: '',
    outcome_year: '',
    outcome_type: 'quarterly',
  };

  homeData_modal: any = {
    outcome_themes: '',
    outcome_quarter: '',
    outcome_year: '',
    outcome_type: 'quarterly',
  };

  dependencies: any = {
    quarter: '',
    outcome_year:''
  };

  dashboardData: any = {
    outcome_themes: '',
    outcome_groups: '',
    member_id: '',
    group_members: '',
    outcome_status: '',
    outcome_type: '',
    parent_group: '',
    outcome_quarters: '',
    outcome_year:new Date().getFullYear(),
  };

  // dependecies
  public selectedDependenciesQuarter: any = null;
  public selectedDependenciesYear: any = null;

  // progress dashboard
  public selectedProgressDashboardBusinessTheme: any = null;
  public selectedProgressDashboardSubgroup: any = null;
  public selectedProgressDashboardGroup: any = null;
  public selectedProgressDashboardMembers: any = null;
  public selectedProgressDashboardRoles: any = null;
  public selectedProgressDashboardoutcome_quarters: any = null;
  public selectedProgressDashboardoutcome_status: any = null;
  public selectedProgressDashboardYear: any = null;
  public selectedChartProgressDashboardYear: any = null;

  // outcomes
  public selectedOutcomeBusinessTheme: any = null;
  public selectedOutcomeSubgroup: any = null;
  public selectedOutcomeGroup: any = null;
  public selectedOutcomeMembers: any = null;
  public selectedOutcomeRoles: any = null;
  public selectedOutcomeAnnualOutcomeStatus: any = null;
  public selectedOutcomeUntouched: any = null;
  public is_affiliate: any = 'no';
  public selectedOutcomeYear: any = null;

  // wp list

  public selectedWPYear: any = null;
  public selectedBusinessTheme: any = null;
  public selectedBrand: any = null;
  public selectedTherapeuticArea: any = null;
  public selectedIndication: any = null;
  public selectedStatus: any = null;
  public selectedUserType: any = null;
  public selectedMember: any = null;

  // task
  public selectedTaskQuarter: any = null;
  public selectedTaskStatus: any = null;
  public selectedTaskThemeId: any = null;
  public selectedTaskType: any = null;
  public selectedTaskYear: any = null;

  //home
  public selectedHomeYear: any = null;
  public selectedHomeQuarter: any = null;
  public selectedHomeThemeId: any = null;

  // kanban 
  public selectedKanbanDashboardYear: any = null;
  public selectedKanbanDashboardGroup: any = null;
  public selectedKanbanDashboardMembers: any = null;


  //dashboard
  public selectedWPDashboardMember=null

  // homedata modal
  public selectedHomeModalYear: any = null;
  public selectedHomeModalQuarter: any = null;
  public selectedHomeModalThemeId: any = null;

  public selectedTaskUntouched: any = null;
  loading: boolean = false;
  constructor() {}

  clearDependencies(){
    this.selectedDependenciesQuarter = null;
    this.selectedDependenciesYear=null

    for (const key in this.dependencies) {
      if (this.dependencies.hasOwnProperty(key) && key !== "outcome_type") {
        this.dependencies[key] = ""; 
      }
    }
  }

  cleanHomeSelection() {
    this.selectedHomeThemeId = null;
    this.selectedHomeQuarter = null;
    this.selectedHomeYear = null;

    for (const key in this.homeData) {
      if (this.homeData.hasOwnProperty(key) && key !== "outcome_type") {
        this.homeData[key] = ""; 
      }
    }
  }

  cleanHomeProgressDashboardSelection() {
    this.selectedProgressDashboardBusinessTheme = null;
    this.selectedProgressDashboardSubgroup = null;
    this.selectedProgressDashboardGroup = null;
    this.selectedProgressDashboardMembers = null;
    this.selectedProgressDashboardRoles = null;
    this.selectedProgressDashboardoutcome_quarters = null;
    this.selectedProgressDashboardoutcome_status = null;
    this.selectedProgressDashboardYear = null;
    this.selectedChartProgressDashboardYear = null;

    for (const key in this.dashboardData) {
      if (this.dashboardData.hasOwnProperty(key) && key !== "outcome_year") {
        this.dashboardData[key] = ""; 
      }
    }
  }

  cleanHomeModalSelection() {
    this.selectedHomeModalThemeId = null;
    this.selectedHomeModalQuarter = null;
    this.selectedHomeModalYear = null;
  }

  cleanTaskSelection() {
    this.selectedTaskQuarter = null;
    this.selectedTaskStatus = null;
    this.selectedTaskThemeId = null;
    this.selectedTaskType = null;
    this.selectedTaskYear = null;
    this.selectedTaskUntouched = null;

    for (const key in this.myTasksData) {
      if (this.myTasksData.hasOwnProperty(key) && key !== "year") {
        this.myTasksData[key] = ""; 
      }
    }
  }

  cleanOutcomesSelection() {
    this.selectedOutcomeBusinessTheme = null;
    this.selectedOutcomeSubgroup = null;
    this.selectedOutcomeYear = null;
    this.selectedOutcomeGroup = null;
    this.selectedOutcomeMembers = null;
    this.selectedOutcomeRoles = null;
    this.selectedOutcomeAnnualOutcomeStatus = null;
    this.selectedOutcomeUntouched = null;

    for (const key in this.outcomeData) {
      if (this.outcomeData.hasOwnProperty(key) && !['outcome_year', 'is_affiliate'].includes(key)) {
        this.outcomeData[key] = ""; 
      }
    }
    
  }

  clearWPSelection() {
    this.selectedWPYear = null;
    this.selectedBusinessTheme = null;
    this.selectedMember = null;
    this.selectedIndication = null;
    this.selectedUserType = null;
    this.selectedStatus = null;
    this.selectedBrand = null;
    this.selectedTherapeuticArea = null;

    for (const key in this.wpData) {
      if (this.wpData.hasOwnProperty(key) ) {
        this.wpData[key] = ""; 
      }
    }
  }

  performSearch(url: string, body: any) {
    this.loading = true;
    return this.httpService.post(url, body).pipe(
      map((res: any) => res?.data || []),
      finalize(() => (this.loading = false))
    );
  }
}
